export default __webpack_public_path__ + "static/media/reset-password.f3371ba6.png";